

function formatLabel(text: string): string {
    if (!text) return '';
  
    let formattedText = text.charAt(0).toUpperCase();

    for (let i = 1; i < text.length; i++) {
        const char = text.charAt(i);
        const prevChar = text.charAt(i - 1);

        if (char === char.toUpperCase() && prevChar !== prevChar.toUpperCase()) {
            formattedText += ' ' + char;
        } else {
            formattedText += char;
        }
    }
  
    return formattedText;
  }
  
export default formatLabel